import * as React from 'react'

import { SVGResponsive } from './common'

function CaretUp() {
  return (
    <SVGResponsive height={8} width={14}>
      <path
        d="M13 7L7 0.999999L1 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVGResponsive>
  )
}

export default React.memo(CaretUp)
